import { TimeOption } from 'design-system-web/components/DatePicker/helpers';

export type { TimeOption };

const BASE_DATE = (() => {
  const d = new Date();

  d.setHours(0, 0, 0, 0);

  return d;
})();

const NEXT_MIDNIGHT = (() => {
  const d = new Date(BASE_DATE);

  d.setDate(d.getDate() + 1);

  return d;
})();

// Returns minutes since midnight for an ISO string.
// Next-day midnight (end-of-day 12:00 AM) is treated as 1440 instead of 0.
export function minutesOfDay(iso: string): number {
  const d = new Date(iso);

  if (d.getDate() !== BASE_DATE.getDate()) return 1440;

  return d.getHours() * 60 + d.getMinutes();
}

function optMinutes(opt: TimeOption): number {
  if (opt.date.getDate() !== BASE_DATE.getDate()) return 1440;

  return opt.date.getHours() * 60 + opt.date.getMinutes();
}

// 48 slots: 12:00 AM → 11:30 PM (used for start time)
const START_TIMES: TimeOption[] = Array.from({ length: 48 }, (_, i) => {
  const d = new Date(BASE_DATE);

  d.setMinutes(i * 30);

  return { date: d };
});

// 49 slots: 12:00 AM → 11:30 PM + 12:00 AM next day (used for end time)
const END_TIMES: TimeOption[] = [...START_TIMES, { date: NEXT_MIDNIGHT }];

export function buildStartTimes(endTime: string | null): TimeOption[] {
  if (!endTime) return [...START_TIMES];

  const endMin = minutesOfDay(endTime);

  return START_TIMES.map(opt => ({ ...opt, disabled: optMinutes(opt) >= endMin }));
}

export function buildEndTimes(startTime: string | null): TimeOption[] {
  if (!startTime) return [...END_TIMES];

  const startMin = minutesOfDay(startTime);
  
  return END_TIMES.map(opt => ({ ...opt, disabled: optMinutes(opt) <= startMin }));
}
